<template>
  <!-- start 键盘-->
  <div class="keyboard">
    <div
      :class="[
        item.type == 5 ? 'blank' : '',
        item.type == 4 ? 'shift' : '',
        item.type == 3 ? 'caps-Lock' : '',
        item.type == 2 ? 'enter' : '',
        item.type == 1 ? 'tab' : '',
        item.type == 0 ? 'common-key' : '',
        item.colorType == 1 && item.select == 0 ? 'color-type-one' : '',
        item.colorType == 2 && item.select == 0 ? 'color-type-two' : '',
        item.colorType == 3 && item.select == 0 ? 'color-type-three ' : '',
        item.select == 1 ? 'correct-view' : '',
        item.select == 2 && item.type != 2 ? 'mistake' : '',
      ]"
      v-for="(item, key) in KeypadList"
      :key="key"
      :style="
        key != 14 && key != 28 && key != 53 && key != 61
          ? 'margin-right:6px;'
          : ''
      "
    >
      <template v-if="item.type == 2">
        <div
          class="enter-view"
          :class="[
            item.select == 1 ? 'correct-view' : '',
            item.select == 2 ? 'mistake' : '',
          ]"
        >
          <div class="interior-vessel">
            <span v-if="item.select != 2" style="margin-top: 55px">Enter</span>
            <span
              v-if="item.select == 2"
              style="margin-top: 55px"
              class="mistake-icon"
              >X</span
            >
          </div>
          <div
            class="left-view"
            :class="[
              item.select == 1 ? 'correct-view' : '',
              item.select == 2 ? 'mistake' : '',
            ]"
          >
            <div class="left-view-interior-vessel"></div>
          </div>
        </div>
      </template>
      <template v-if="key == 41">
        <div class="placeholder-view"></div>
      </template>
      <template
        v-if="item.distribute == 0 && item.type != 2 && item.select != 2"
      >
        <div class="interior-key separate-align">
          <div>{{ item.valOne }}</div>
          <div>{{ item.valTow }}</div>
        </div>
      </template>
      <template v-if="item.distribute == 1 && item.select != 2">
        <div class="interior-key below-align">
          <div>{{ item.valOne }}</div>
        </div>
      </template>
      <template v-if="item.distribute == 2 && item.select != 2">
        <div
          class="interior-key"
          :class="
            item.type == 1 || item.type == 3 ? 'special-align' : 'center-align'
          "
        >
          <div
            v-if="item.valOne != 'Win' && item.valOne != '书本'"
            :class="item.code == 'ShiftLeft' ? 'left-text' : ''"
          >
            {{ item.valOne }}
          </div>
          <img v-if="item.valOne == 'Win'" src="@/assets/images/win-icon.png" />
          <img
            v-if="item.valOne == '书本'"
            src="@/assets/images/book-icon.png"
          />
        </div>
      </template>
      <template v-if="item.select == 2">
        <div class="interior-key center-align">
          <div class="mistake-icon">X</div>
        </div>
      </template>
    </div>
  </div>
  <!-- end 键盘 -->
</template>

<script>
export default {
  name: "KeyboardPro",
  data() {
    return {
      // 键盘数据列表
      KeypadList: [],
    };
  },
  props: {
    // 键位值
    displayObjects: {
      typeof: Object,
      default: function () {
        return {
          presetValue: null, // 预设值
          inputValue: null, // 键入值
          isCorrect: false, //是否正确
        };
      },
    },
    // 比较类型
    comparisonType: {
      typeof: Boolean,
      default: false,
    },
    // 是否显示提示
    isShowHint: {
      typeof: Boolean,
      default: true,
    },
  },
  watch: {
    isShowHint: {
      handler(newObj) {
        if (!newObj) {
          this.initializeKeyValue();
        }
      },
    },
    displayObjects: {
      deep: true,
      handler(newObj) {
        if (this.isShowHint) {
          this.keyboardTip(newObj);
        }
      },
    },
  },
  created() {
    this.getKeypadList();
  },
  methods: {
    // 键盘提示
    keyboardTip(obj) {
      let keyLocation = null;
      let correct = null;
      this.initializeKeyValue();
      if (!this.comparisonType) {
        this.KeypadList.forEach((item, key) => {
          if (item != undefined) {
            if (this.comparison(obj.presetValue, item.valOne, item.valTow)) {
              this.KeypadList[key].select = 1;
              correct = key;
            }
            if (obj.inputValue != null && obj.inputValue == item.code) {
              keyLocation = key;
            }
          }
        });
        if (obj.isCorrect == false && keyLocation != null) {
          this.KeypadList[keyLocation].select = 2;
          let that = this;
          setTimeout(function () {
            if (keyLocation == correct) {
              that.KeypadList[keyLocation].select = 1;
            }else{
              that.KeypadList[keyLocation].select = 0;
            }
          }, 400);
        }
      } else {
        this.KeypadList.forEach((item, key) => {
          if (item != undefined) {
            if (this.comparison(obj.presetValue, item.valOne, item.valTow)) {
              this.KeypadList[key].select = 1;
            }
            if (this.comparison(obj.inputValue, item.valOne, item.valTow)) {
              keyLocation = key;
            }
          }
        });
        if (obj.isCorrect == false && keyLocation != null) {
          this.KeypadList[keyLocation].select = 2;
          let that = this;
          setTimeout(function () {
            that.KeypadList[keyLocation].select = 0;
          }, 400);
        }
      }
    },
    // 对比键值
    comparison(presetValue, valOne, valTow) {
      if (presetValue == null) {
        return;
      }
      var reg = new RegExp(/[a-zA-Z]/);
      if (valOne != null && reg.test(valOne)) {
        if (valOne.toLowerCase() == presetValue.toLowerCase()) {
          return true;
        }
      } else {
        if (valOne == presetValue || valTow == presetValue) {
          return true;
        }
      }
      return false;
    },
    // 获取键位
    getKeypadList() {
      this.$http({
        url: "/static/json/keyMappingJsonList.json",
        method: "get",
      }).then(({ data }) => {
        this.KeypadList = data.data;
        if (this.isShowHint) {
          this.keyboardTip(this.displayObjects);
        }
      });
    },
    // 初始化
    initializeKeyValue() {
      this.KeypadList.forEach((item, key) => {
        if (item != undefined || item.select != undefined) {
          this.KeypadList[key].select = 0;
        }
      });
    },
    // 正确值，预键入值
    typeTheValue() {},
  },
};
</script>

<style scoped lang="scss">
.keyboard {
  margin-top: 18px;
  width: 898px;
  background: #e1e0e7;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #d3d2db;
  padding: 5px 8px;
  box-sizing: border-box;

  display: flex;
  flex-flow: wrap;
  .common-key {
    width: 53px;
    height: 55px;
    //background: #c3acd2;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #482762;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    padding: 4px;
    box-sizing: border-box;
    font-size: 16px;
    //font-weight: 800;
    color: #000000;
    margin-bottom: 3px;
  }
  .interior-key {
    //width: 43px;
    //height: 44px;
    height: 44px;
    //background: linear-gradient(180deg, #e6dcee 0%, #c9b4dc 100%);
    //box-shadow: 0px 3px 6px 1px rgba(131, 62, 180, 0.4);
    border: 1px solid rgba(255, 255, 255, 0.7019607843137254);
    display: flex;
    //justify-content: center;
  }
  .tab {
    width: 79px;
    height: 55px;
    //background: #c3acd2;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #482762;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    padding: 5px;
    box-sizing: border-box;
    font-size: 16px;
    //font-weight: 800;
    color: #000000;
    margin-bottom: 3px;
  }
  .shift {
    width: 140px;
    height: 55px;
    //background: #c3acd2;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #482762;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    padding: 5px;
    box-sizing: border-box;
    font-size: 16px;
    //font-weight: 800;
    color: #000000;
    margin-bottom: 3px;
  }
  .blank {
    width: 410px;
    height: 55px;
    //background: #c3acd2;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #482762;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    padding: 5px;
    box-sizing: border-box;
    font-size: 16px;
    //font-weight: 800;
    color: #000000;
    margin-bottom: 3px;
  }
  .enter {
    width: 86px;
    height: 55px;
    // background: #c3acd2;
    // border-radius: 3px 3px 3px 3px;
    // border: 1px solid #482762;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    // padding: 5px;
    // box-sizing: border-box;
    // font-size: 16px;
    // font-weight: 800;
    // color: #000000;
    // margin-bottom: 3px;
  }
  .caps-Lock {
    width: 112px;
    //background: #c3acd2;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #482762;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    padding: 5px;
    box-sizing: border-box;
    font-size: 16px;
    //font-weight: 800;
    color: #000000;
    margin-bottom: 3px;
  }
  .separate-align {
    flex-wrap: wrap;
    align-items: center;
    flex-flow: column;
  }
  .center-align {
    align-items: center;
    justify-content: center;
  }
  .special-align {
    text-align: left;
    align-items: center;
    padding-left: 12px;
  }
  .below-align {
    align-items: flex-end;
    justify-content: center;
    box-sizing: border-box;
  }

  .enter-view {
    width: 86px;
    height: 112px;
    background: #c3acd2;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #482762;
    padding: 5px;
    box-sizing: border-box;
    position: relative;
    .interior-vessel {
      height: 100%;
      background: linear-gradient(180deg, #e6dcee 0%, #c9b4dc 100%);
      box-shadow: 0px 3px 6px 1px rgba(131, 62, 180, 0.4);
      border: 1px solid rgba(255, 255, 255, 0.7019607843137254);
      display: flex;
      justify-content: center;
    }
    .left-view {
      position: absolute;
      width: 28px;
      height: 52px;
      background: #c3acd2;
      bottom: -1px;
      left: -26px;
      border-top: 1px solid #482762;
      border-left: 1px solid #482762;
      border-bottom: 1px solid #482762;
      padding: 3px 0 3px 5px;
      box-sizing: border-box;
      .left-view-interior-vessel {
        width: 30px;
        height: 100%;
        background: linear-gradient(180deg, #d5c5e4 0%, #c9b4dc 100%);
        //box-shadow: 0px 3px 6px 0px rgba(131, 62, 180, 0.4);
        border: 1px solid rgba(255, 255, 255, 0.7019607843137254);
        border-right: none;
        box-sizing: border-box;
      }
    }
  }
  .placeholder-view {
    width: 100px;
    height: 55px;
  }

  .color-type-one {
    background: #c3acd2;
    .interior-key {
      background: linear-gradient(180deg, #e6dcee 0%, #c9b4dc 100%);
      box-shadow: 0px 3px 6px 1px rgba(131, 62, 180, 0.4);
    }
  }
  .color-type-two {
    background: #b4c3df;
    .interior-key {
      box-shadow: 0px 3px 6px 1px rgba(82, 107, 153, 0.4);
      background: linear-gradient(180deg, #dce1f0 0%, #b0bbdd 100%);
    }
  }
  .color-type-three {
    background: #bdd7ba;
    .interior-key {
      box-shadow: 0px 3px 6px 1px rgba(48, 92, 40, 0.4);
      background: linear-gradient(180deg, #dfecdf 0%, #b9d4bd 100%);
    }
  }
  .correct-view {
    background: linear-gradient(180deg, #79ffff 0%, #46c4ff 100%) !important;

    border-radius: 3px 3px 3px 3px;
    .interior-key {
      border: 1px solid #ffffff;
      box-shadow: 0px 3px 6px 1px rgba(0, 124, 245, 0.4);
      background: linear-gradient(180deg, #bfffff 0%, #51c8ff 100%);
    }

    .interior-vessel {
      box-shadow: 0px 3px 6px 1px rgba(0, 124, 245, 0.4) !important;
      background: linear-gradient(180deg, #bfffff 0%, #51c8ff 100%) !important;
    }

    .left-view-interior-vessel {
      box-shadow: 0px 3px 6px 1px rgba(0, 124, 245, 0.4) !important;
      background: linear-gradient(
        180deg,
        rgb(128, 225, 255) 0%,
        #51c8ff 100%
      ) !important;
    }
  }

  .mistake {
    //border: 1px solid #585858;
    border-radius: 3px 3px 3px 3px;
    background: #ffbd5d !important;
    .interior-key {
      border: 1px solid rgba(255, 255, 255, 0.7019607843137254);
      box-shadow: 0px 3px 6px 1px rgba(236, 103, 0, 0.4);
      background: linear-gradient(180deg, #ffdec6 0%, #ffc168 100%);
    }

    .interior-vessel {
      background: linear-gradient(180deg, #ffdec6 0%, #ffc168 100%) !important;
      box-shadow: 0px 3px 6px 1px rgba(236, 103, 0, 0.4) !important;
    }

    .left-view-interior-vessel {
      background: linear-gradient(
        180deg,
        rgb(255, 205, 144) 0%,
        #ffc168 100%
      ) !important;
      box-shadow: 0px 3px 6px 1px rgba(236, 103, 0, 0.4) !important;
    }
  }

  .mistake-icon {
    color: red;
    //font-weight: 900;
    font-size: 26px;
  }
}

.shift > .interior-key {
  justify-content: left !important;
  padding-left: 14px;
}
</style>
